import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../../lib/api";
import ProjectCard from "../../components/ProjectCard";
import Reveal, { Eyebrow } from "../../components/Reveal";

export default function ProjectsPreview() {
  const [projects, setProjects] = useState(null);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data.slice(0, 6))).catch(() => setProjects([]));
  }, []);

  return (
    <section data-testid="projects-preview-section" className="py-16 md:py-24 lg:py-28 bg-paper">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
            <div>
              <Eyebrow>Our Projects</Eyebrow>
              <h2 className="mt-4 font-display font-bold text-3xl md:text-5xl tracking-tight text-ink display-expanded leading-[1.02]">
                Recent Work Around<br />the Region.
              </h2>
            </div>
            <Link to="/projects" data-testid="projects-preview-view-all" className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.18em] uppercase text-slate2 hover:text-ink transition-colors shrink-0">
              View All Projects <ArrowRight className="w-4 h-4 text-gold" />
            </Link>
          </div>
        </Reveal>

        {projects === null ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[0, 1, 2].map((i) => <div key={i} className="aspect-[4/3] bg-line/50 animate-pulse" />)}
          </div>
        ) : projects.length === 0 ? (
          <Reveal>
            <div data-testid="projects-empty-state" className="border border-line bg-white px-8 py-14 md:py-20 text-center">
              <img src="/logo-mark-black.png" alt="" className="w-12 mx-auto opacity-25 mb-6" />
              <h3 className="font-display font-semibold text-xl text-ink">Our project gallery is being prepared</h3>
              <p className="mt-3 text-slate2 text-sm max-w-md mx-auto leading-relaxed">
                We're currently photographing recent renovations, extensions and new builds from across the Wellington region. In the meantime, talk to us about what you're planning — we're happy to walk you through relevant past work.
              </p>
              <Link to="/contact" data-testid="projects-empty-cta" className="mt-7 inline-flex items-center gap-2.5 bg-ink hover:bg-charcoal text-white font-mono text-[11px] tracking-[0.18em] uppercase px-6 py-3.5 transition-colors">
                Talk To Us About Your Project <ArrowRight className="w-4 h-4 text-gold" />
              </Link>
            </div>
          </Reveal>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.06}>
                <ProjectCard project={p} index={i} />
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
